"use client"

import { useCartState } from "src/checkout/hooks/useCart"
import { CheckoutStep, setCheckoutStep } from "src/checkout/state/checkoutStageStore"
import { NpButton } from "src/components/np-design/components/button/NpButton"
import { NpIcon } from "src/components/np-design/components/NpIcon"
import { setCartSidebarVisible } from "src/components/np-design/sections/cart-sidebar/state"
import { routes } from "src/config/routes"
import { freeShippingThreshold } from "src/data/feeds/shipping"
import { CheckoutWithPayPalButton } from "src/integrations/paypal/CheckoutWithPayPalButton"
import { formatPriceLong, formatPriceShort } from "src/utilities/price"

export const NpCartSidebarFooter = () => {
  const { data: cart } = useCartState()

  const total = +(cart?.totals.total_price || 0) / 100
  const freeShippingRatio = total / freeShippingThreshold
  const shippingIsFree = freeShippingRatio >= 1

  return (
    <footer className="bg-np-green10 flex w-full flex-col gap-6 p-6">
      <div className="flex flex-col gap-4">
        <NpButton
          href={routes.checkout}
          onClick={() => {
            setCheckoutStep(CheckoutStep.ShippingInfo)
            setCartSidebarVisible(false)
          }}
        >
          Zur Kasse | {formatPriceLong(total)}
        </NpButton>

        <CheckoutWithPayPalButton />
      </div>

      <div className="flex items-center justify-center gap-2 text-center">
        <NpIcon name="package" className="size-8" />
        Gratis Versand innerhalb Deutschlands
        {!shippingIsFree && " ab " + formatPriceShort(freeShippingThreshold) + " Bestellwert"}
      </div>
    </footer>
  )
}
